import { initReactI18next } from 'react-i18next'
import de from 'assets/i18n/de.json'
import en from 'assets/i18n/en.json'
import es from 'assets/i18n/es.json'
import fr from 'assets/i18n/fr.json'
import it from 'assets/i18n/it.json'
import pt from 'assets/i18n/pt.json'
import i18n from 'i18next'

i18n.use(initReactI18next).init({
  resources: {
    en,
    es,
    fr,
    pt,
    de,
    it,
  },
  defaultNS: 'common',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})
